<template>
    <!-- 底部固定填写表单提示 -->
    <div class="fixed_formTip">
        <span class="txt">观看完视频课程，填写问卷表单即可取得证书～</span>
        <span class="btn" @click="toInputForm">去填写</span>
    </div>
</template>
<script>
export default {
  data() {
      return{
          
      }
  },
  methods:{
      toInputForm(){
          this.$emit("toInputForm");
      }
  }
};
</script>
<style scoped lang="stylus">
.fixed_formTip {
    position:fixed;
    bottom:0;
    left:0;
    right:0;
    width: 100%;
    height: 144px;
    background: #FFFFFF;
    box-shadow: -1px -1px 52px 6px rgba(67, 75, 191, 0.13);
    border-radius: 12px;
    display:flex;
    justify-content:center;
    align-items:center;
    z-index:10;

    .txt {
        font-size: 24px;
        color: #1A1A1A;
        line-height: 33px;
        margin-right:250px;
    }

    .btn {
        width: 178px;
        height: 52px;
        background: #0304E5;
        border-radius: 8px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 52px;
        text-align:center;
        cursor:pointer;
    }
}
</style>

